export class ValueTypeAggregation {
  isOpen: boolean;
  tick = 0;
  valueTypeDetail: any[] = [];
  marketValueSubTot = 0;
  plusMinusSubTot = 0;
  varSubTot = 0;
  varDSubTot = 0;
  portfolioSubTot = 0;
  sharesSubTot = 0;
  averageCostSubTot = 0;
  costAmountSubTot = 0;
  costAmountDSubTot = 0;

  constructor(public valueType: number, public valueTypeLabel: string) {
    const valuesArray: number[] = [0, 1, 5];

    this.isOpen = valuesArray.indexOf(this.valueType) >= 0;
  }

  processAggData(): void {
    this.sharesSubTot = 0;
    this.marketValueSubTot = 0;
    this.averageCostSubTot = 0;
    this.costAmountSubTot = 0;
    this.costAmountDSubTot = 0;
    this.plusMinusSubTot = 0;
    this.varSubTot = 0;
    this.varDSubTot = 0;
    this.portfolioSubTot = 0;

    for (const agg of this.valueTypeDetail) {
      agg.processAggValues();

      this.sharesSubTot +=
        agg.shares !== undefined ? agg.shares : agg.position.shares;
      this.averageCostSubTot +=
        agg.averageCost !== undefined
          ? agg.averageCost
          : agg.position.averageCost;
      this.costAmountSubTot += agg.costAmount;
      this.costAmountDSubTot += agg.costAmountD;
      this.marketValueSubTot += agg.marketValue;
      this.plusMinusSubTot += agg.plusMinus;
      this.portfolioSubTot += agg.portfolio;
    }

    this.varSubTot =
      this.costAmountSubTot !== 0
        ? (this.plusMinusSubTot / this.costAmountSubTot) * 100
        : 0;
    this.varDSubTot =
      this.costAmountDSubTot !== 0
        ? (this.plusMinusSubTot / this.costAmountDSubTot) * 100
        : 0;
  }
}
